import { createStore, createHook, type Action } from 'react-sweet-state';
import { getAtlassianAccount } from './get-atlassian-account-info';

type State = {
	loggedInEmailDomain: string | null;
	loading: boolean;
};

const initialState: State = {
	loggedInEmailDomain: null,
	loading: false,
};

export const actions = {
	fetchUserEmailDomain:
		(): Action<State> =>
		async ({ setState, getState }) => {
			const { loading } = getState();

			if (loading) {
				return;
			}
			setState({
				loading: true,
			});

			const accountInfo = await getAtlassianAccount();

			if (accountInfo) {
				const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];

				setState({
					loggedInEmailDomain,
				});
			}

			setState({
				loading: false,
			});
		},
} as const;

type ActionType = typeof actions;

const Store = createStore<State, ActionType>({
	initialState,
	actions,
	name: 'user-email-domain',
});

export const useUserEmailDomain = createHook(Store);
